// frontend/src/components/ui/info-content.js
//
// Centralized registry for InfoButton content. Keys here map to entries in
// `infoButton.<key>.title` / `infoButton.<key>.body` in the i18n bundles.
//
// kind: 'popover'  - short, single-concept, ≤2 sentences
// kind: 'dialog'   - bullet list, multiple concepts, "how this system works"
//
// Add `learnMoreHref` to render a "Learn more →" link in dialogs.

export const INFO_CONTENT = {
  // Identity / Gamification
  streak:           { kind: 'dialog',  titleKey: 'infoButton.streak.title',           bodyKey: 'infoButton.streak.body' },
  level:            { kind: 'dialog',  titleKey: 'infoButton.level.title',            bodyKey: 'infoButton.level.body' },
  goals:            { kind: 'dialog',  titleKey: 'infoButton.goals.title',            bodyKey: 'infoButton.goals.body' },
  aiCoach:          { kind: 'dialog',  titleKey: 'infoButton.aiCoach.title',          bodyKey: 'infoButton.aiCoach.body' },
  leaderboard:      { kind: 'dialog',  titleKey: 'infoButton.leaderboard.title',      bodyKey: 'infoButton.leaderboard.body' },

  // Diet
  macroTargets:     { kind: 'dialog',  titleKey: 'infoButton.macroTargets.title',     bodyKey: 'infoButton.macroTargets.body' },
  adaptiveMacros:   { kind: 'dialog',  titleKey: 'infoButton.adaptiveMacros.title',   bodyKey: 'infoButton.adaptiveMacros.body' },
  reverseDiet:      { kind: 'dialog',  titleKey: 'infoButton.reverseDiet.title',      bodyKey: 'infoButton.reverseDiet.body' },
  fasting:          { kind: 'dialog',  titleKey: 'infoButton.fasting.title',          bodyKey: 'infoButton.fasting.body' },

  // Workout
  pr:               { kind: 'popover', titleKey: 'infoButton.pr.title',               bodyKey: 'infoButton.pr.body' },
  volume:           { kind: 'popover', titleKey: 'infoButton.volume.title',           bodyKey: 'infoButton.volume.body' },
  trophyCase:       { kind: 'dialog',  titleKey: 'infoButton.trophyCase.title',       bodyKey: 'infoButton.trophyCase.body' },
  routinesVsCustom: { kind: 'dialog',  titleKey: 'infoButton.routinesVsCustom.title', bodyKey: 'infoButton.routinesVsCustom.body' },
  restTimer:        { kind: 'popover', titleKey: 'infoButton.restTimer.title',        bodyKey: 'infoButton.restTimer.body' },

  // Progress & Health
  measurements:     { kind: 'dialog',  titleKey: 'infoButton.measurements.title',     bodyKey: 'infoButton.measurements.body' },
  recovery:         { kind: 'dialog',  titleKey: 'infoButton.recovery.title',         bodyKey: 'infoButton.recovery.body' },
  transformation:   { kind: 'dialog',  titleKey: 'infoButton.transformation.title',   bodyKey: 'infoButton.transformation.body' },

  // Coach-side
  complianceBar:    { kind: 'popover', titleKey: 'infoButton.complianceBar.title',    bodyKey: 'infoButton.complianceBar.body' },
  healthBadge:      { kind: 'popover', titleKey: 'infoButton.healthBadge.title',      bodyKey: 'infoButton.healthBadge.body' },
  coachAutomations: { kind: 'dialog',  titleKey: 'infoButton.coachAutomations.title', bodyKey: 'infoButton.coachAutomations.body' },

  // Social / Privacy
  privacyModes:     { kind: 'dialog',  titleKey: 'infoButton.privacyModes.title',     bodyKey: 'infoButton.privacyModes.body' },
};
